const getNextParam = () => {
  const params = new URLSearchParams(document.location.search.substring(1));
  return params.get("next");
};

export default getNextParam;
